module.exports = __webpack_public_path__ + "img/banner.eaba4036.jpg";